import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { PoDetailsComponent } from './details/po-details.component';

import { PoListComponent } from './list/po-list.component';
import { PoRestService } from './po-rest.service';
import { PoRoutingModule } from './po-routing.module';
import { OrderListSummaryComponent } from './list-summary/order-list-summary.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

export const PROVIDERS = [PoRestService];

@NgModule({
  imports: [
    BsDropdownModule,
    CheckboxModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PoRoutingModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule
  ],
  declarations: [PoListComponent, PoDetailsComponent, OrderListSummaryComponent]
})
export class PoModule {}
